import widgetTransformer from '@nykaa/deals-transformer';
import { Inventory } from 'shared/store/home/types';


export const transformWidgetsData = (data :Inventory[], pagePrefix?: string) => (widgetTransformer(data, false, __PLATFORM__, pagePrefix));
